import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Button,
  Tooltip,
} from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import AccountCircle from "@mui/icons-material/AccountCircle";
import LogoutIcon from "@mui/icons-material/Logout";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";

const TopBar = () => {
  const { user, isAuthorised } = useSelector((state) => state.authentication);
  const navigate = useNavigate();

  const handleHomeNavigation = () => {
    navigate("/ahpra-validation-tool/dashboard");
  };

  const handleIndividualSearch = () => {
    navigate("/ahpra-validation-tool/dashboard/individual-search");
  };

  const handleRecordHandling = () => {
    navigate("/ahpra-validation-tool/dashboard/record-handling");
  };

  const handleToolExit = () => {
    navigate("/offerings");
  };

  return (
    <AppBar position="static" sx={{ backgroundColor: "#2E3B55" }}>
      <Toolbar>
        <Typography
          variant="h4"
          sx={{ flexGrow: 1, fontFamily: "Montserrat, sans-serif" }}
        >
          AHPRA Validation Tool
        </Typography>

        <IconButton
          color="inherit"
          aria-label="home"
          sx = {{ padding: 2 }}
          onClick={handleHomeNavigation}
        >
          <HomeIcon />
        </IconButton>

        <Button
          color="inherit"
          sx={{
            backgroundColor: "white",
            color: "#2E3B55",
            border: "1px solid #2E3B55",
            marginRight: 2,
            "&:hover": {
                color: "white",  
                backgroundColor: "#2E3B55",
                border: "1px solid white"
            },
            borderRadius: "8px",
            padding: "8px 16px",
            fontWeight: "bold",
          }}
          onClick={handleIndividualSearch}
        >
          Individual Search
        </Button>
        <Button
          color="inherit"
          sx={{
            backgroundColor: "white",
            color: "#2E3B55",
            marginRight: 2,
            border: "1px solid #2E3B55",
            "&:hover": {
              color: "white",  
              backgroundColor: "#2E3B55",
              border: "1px solid white"
            },
            borderRadius: "8px",
            padding: "8px 16px",
            fontWeight: "bold",
          }}
          onClick={handleRecordHandling}
        >
          Record Handling
        </Button>

        {isAuthorised && user.userName && (
          <Typography
            variant="subtitle1"
            sx={{
              color: "white",
            }}
          >
            {user.userName}
          </Typography>
        )}

        <IconButton color="inherit" aria-label="user">
          <AccountCircle />
        </IconButton>
        <Tooltip title="Exit Tool">
        <IconButton
          color="inherit"
          aria-label="logout"
          onClick={handleToolExit}
        >
          <LogoutIcon />
        </IconButton>
        </Tooltip>
      </Toolbar>
    </AppBar>
  );
};

export default TopBar;
